import { DefaultLanguage, i18n } from 'i18n-utils'
import { AppServices } from 'network'
import { ref } from 'vue'
import { StorageKeys } from '../constants/static-table-sv-id'
import { useChangeLanguage } from '../hooks/use-change-language'
import { storageDB } from '../storage/StorageDB'

export const useLanguageStore = defineStore('language', () => {
  const initLang = (window.localStorage.getItem(StorageKeys.CurrentLanguage) as string) || 'zh_CN'
  const currentLanguage = ref<string>(initLang)
  const languageMap = ref<Record<string, Record<string, string>>>({})
  const oldLang = ref<string>(initLang)
  const loading = ref(false)

  const getLangKey = (langKey: string) => {
    return `${import.meta.env.VITE_PLATFORM}-language-${langKey}`
  }

  const cacheLang = (langKey: string, langValue: Record<string, string>) => {
    storageDB.set(getLangKey(langKey), langValue)
  }

  const setLang = () => {
    i18n.global.setLocaleMessage(currentLanguage.value, {
      ...DefaultLanguage,
      ...(languageMap.value[currentLanguage.value] || languageMap.value[oldLang.value]),
    })
    i18n.global.locale = currentLanguage.value
    oldLang.value = currentLanguage.value
  }

  /**
   * 获取语言包数据
   * @returns
   */
  const fetchLanguage = async () => {
    // 如果有缓存，先赋值
    loading.value = true
    storageDB.get<Record<string, string>>(getLangKey(currentLanguage.value)).then((cacheRes) => {
      if (cacheRes) {
        languageMap.value[currentLanguage.value] = cacheRes
        setLang()
      }
    })

    const res = await AppServices.getLanguage({
      lang: currentLanguage.value,
    })

    loading.value = false
    if (res.status === 200) {
      languageMap.value[currentLanguage.value] = res.data[currentLanguage.value]
      cacheLang(currentLanguage.value, res.data[currentLanguage.value])
      setLang()
    }
    return res.data
  }

  useChangeLanguage(async (data) => {
    if (data?.oldLang !== data?.newLang) {
      await fetchLanguage()
    }
  })

  const setCurrentLanguage = (language: string) => {
    if (language === currentLanguage.value) return
    currentLanguage.value = language
    window.localStorage.setItem(StorageKeys.CurrentLanguage, language)
  }

  const isZH = computed(() => {
    return currentLanguage.value === 'zh_CN'
  })

  const isEn = computed(() => {
    return currentLanguage.value === 'en'
  })

  return {
    isZH,
    currentLanguage,
    fetchLanguage,
    languageMap,
    setCurrentLanguage,
    loading,
    isEn,
  }
})
